/**
 * Change blog to CTA
 * Updates privacyPolicy for Form CTAs
 * @returns {cta} adds a class to the blog tile to change it into a CTA for sales streams.
 */

const loopTiles = () => {
    const liTags = document.querySelectorAll('.tile');
    if (liTags) {
        liTags.forEach((tags) => {
            const dataTags = tags.dataset.tags;
            if (tags.dataset.tags !== undefined) {
                if (dataTags.indexOf('tagged-cta') !== -1) {
                    tags.classList.add('tagged-cta');
                    tags.setAttribute('id', tags.getAttribute('data-id'));
                    if (tags.querySelector('.item-link.view')) {
                        const buttonText = tags.querySelector('.description h4');
                        if (buttonText) {
                            tags.querySelector('.item-link.view').innerHTML = buttonText.innerHTML;
                        } else {
                            tags.querySelector('.item-link.view').classList.add('hide');
                        }
                    }
                }
                if (dataTags.indexOf('no-text-cta') !== -1) {
                    if (tags.querySelector('.item-link.view')) {
                        tags.querySelector('.item-link.view').classList.add('hide');
                    }
                    if (tags.querySelector('.description .h3like')) {
                        tags.querySelector('.description .h3like').classList.add('hide');
                    }
                }

            }
            let img = tags.querySelector('img');
            if (img) {
                if (/mediaproxy/.test(img.src)) {
                    const newImg = decodeURIComponent(img.src.split('url=')[1]);
                    img = newImg.split('&')[0].split('?')[0];
                    tags.querySelector('.img>img').setAttribute('src', img);
                    tags.querySelector('.img>img').classList.add('ob-raw-image');
                }
            }
        });
    }
};

export { loopTiles };


// WEBPACK FOOTER //
// ./scriptPartials/tiles.js